import React, { useEffect, useState } from "react";
//internal and external components import
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { Chip, TableRow, Tooltip, Typography } from "@mui/material/";
import {
  sortData,
} from "../../common/SortSupport";
import { EnhancedTableHead } from "../EnhancedTableHead";
import { Box } from "@mui/material";
import StatusIndicatorSmall from "../StatusIndicatorSmall";
import { AvatarAndName } from "../AvatarAndName";
import { baseUrl } from "../../api/config";
import logo from '../../assets/icons/JLogo.svg';
import { useTranslation } from "react-i18next";
import SelectBoxPrimary from "../SelectBoxPrimary";
import { useDispatch, useSelector } from "react-redux";
import ActionSelectBox from "../SearchSelectBox/ActionSelectBox";
import AutoComplete from "../AutoComplete";
import StaffSelectBox from "../SearchSelectBox/StaffSelectBox";
import DateSelector from "../DateSelector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEyeSlash, faLinkSlash, faPen, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import TableSkeleton from "../TableSkeleton";
import { capitalizeKeys, formatDate, genUID } from "../../common/StaticExports";
import { deleteAction, getAllActions, updateActions } from "../../api/action";
import { getStaff } from "../../api/user";
import { getEvaluationCriteriaStandards } from "../../api/evaluation";
import { setStaffList } from "../../redux/reducers/evaluation";
import NestedThreeDotMenu from "../NestedThreeDotMenu";
import { unassignAction } from "../../api/projects";
import ActionDetailPopper from "../../containers/ActionDetailPopper";

const ReportsActionsTable = (props:any) => {
    const { data, addAction, discardAddAction, criteria } = props;
    const [t] = useTranslation();
    const [actionData, setActionData] = useState(data);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const [actionList, setActionList] = useState([]);
    // const [staffList, setStaffList] = useState([]);
    const [standardsList, setStandardsList] = useState([]);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const staffList = useSelector((state:any) => state.evaluation.staffList);
    const [actionToEdit, setActionToEdit] = useState(null);
    const initialAction = {
      name: '',
      description: '',
      dueDate: null,
      ragb: 4,
      status: 4,
      ownerName: '',
      ownerUserId: null,
      isCreatedByJL: isAdmin,
      standardHistory: [],
    };
    const [newAction, setNewAction]:any = useState(initialAction);
    const dispatch = useDispatch();

  //supporting contents
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("Uid");

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  let visibleRows = React.useMemo(
    () =>
      actionData && actionData.length > 0 && sortData(actionData, orderBy, order),
    [order, orderBy, actionData]
  );

  const fetchActionList = async () => {
      const response = await getAllActions({ clubId: clubDetails.id, isSelfAssessment: true });
      setActionList(response);
  }
  const fetchStaffList = async () => {
    const response = await getStaff({ clubId: clubDetails?.id });
    dispatch(setStaffList(response));
  }
  const fetchStandardsList = async () => {
    const response = await getEvaluationCriteriaStandards({clubId: clubDetails.id, criteriaId: criteria.Id});
    setStandardsList(response);
  }

  useEffect(() => {
    if (addAction) {
      fetchActionList();
      fetchStandardsList();
    }
    data != null && staffList?.length == 0 && fetchStaffList();
  }, [ addAction, data ])
  
  const manageStandardSelect = (stand:any) => {
    const index = newAction.standardHistory.findIndex((obj:any) => obj.id == stand.id);
    let tempArr:any = [...newAction.standardHistory];
    if (index !== -1) {
        tempArr.splice(index, 1);
    } else {
      tempArr.push(stand);
    }
    setNewAction({...newAction, standardHistory: tempArr});
  }

  const fetchUserDetails:any = (userId:any) => {
    return staffList?.find((d:any) => d.id == userId);
  }
  
  const manageCreateClick = () => {
    setIsAddLoading(true);
    newAction?.standardHistory.map(async (sh:any) => {
          const response = await updateActions({ clubId: clubDetails?.id, standardId: sh.id, actions: [newAction] });
          console.log('response', response);
    })
    const sortedNewAction = capitalizeKeys(newAction);
    discardAddAction();
    setNewAction(initialAction);
    setActionData([sortedNewAction, ...actionData]);
    setIsAddLoading(false);
  }

  const head = [
    {
      key: "Id",
      displayName: "id",
    },
    {
      key: "Name",
      displayName: "action",
    },
    {
      key: "Description",
      displayName: "description",
    },
    {
      key: "Uid",
      displayName: "Standard",
    },
    {
      key: "",
      displayName: "",
    },
  ];

  const threeDotMenuOptions =
  [
    {label: 'Edit Action', icon: faPen, isDisabled: false},
    // {label: 'Unlink Action', icon: faLinkSlash, isDisabled: false},
    {label: 'Archive Action', icon: faEyeSlash, isDisabled: false},
    {label: 'Delete Action', icon: faTrash, isDisabled: false},
  ];
  
  const handleThreedotMenuClick = (selctedAction:any, action:any) => {
    switch(selctedAction) {
      case 'Delete Action': 
        deleteAction({actionId: action.id});
        break;
      case 'Archive Action': 
        deleteAction({actionId: action.id});
        break;
      case 'Edit Action':
        setActionToEdit(action);
        break;
    }
  }

  //table contents
  return (
    <React.Fragment>
      <ActionDetailPopper isOpen={actionToEdit !== null} handleIsOpen={() => {setActionToEdit(null)}} data={actionToEdit} />
      <Box className={'mb20'}>
        <TableContainer>
          <Table stickyHeader size="small" aria-label="a dense table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              tableHeads={head}
            />
            {
              !isAddLoading && addAction ? 
              <TableRow
              sx={{ cursor: 'pointer' }}
              key={`actions-table-row-create`}
              >
                  <TableCell className='fs12'>
                    {'-'}
                  </TableCell>
                  <TableCell className='fs12'>
                    <ActionSelectBox optionList={actionList} variant={'standard'} selected={newAction.name} manageActionSelect={(data:any) => {
                      if (data && Object.keys(data).includes('id')) {
                        setNewAction({...data, IsCreatedByJL: isAdmin, projectName: '', standardHistory: []});
                      } else {
                        setNewAction({...newAction, ...data, standardHistory: []});
                      }
                      }}/>
                  </TableCell>
                  <TableCell width={'480px'}>
                    {newAction.Description}
                  </TableCell>
                  <TableCell className='fs12' width={'420px'}>
                    <AutoComplete 
                    options={standardsList}
                    selectedValues={newAction.standardHistory}
                    key={'uid'}
                    handleMenuClick={(d:any) => {manageStandardSelect(d)}} 
                    clickReset={() => {setNewAction({...newAction, standardHistory: []})}}
                    isMultiple={true}
                    variant={'standard'}
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex' }}>
                      <Tooltip title='Delete' arrow placement='top'><FontAwesomeIcon onClick={() => {setNewAction(initialAction); discardAddAction(); }} className={'icon mr10'} icon={faXmark}/></Tooltip>
                      <Tooltip title='Create' arrow placement='top'><FontAwesomeIcon onClick={() => {manageCreateClick()}} className={'icon mr10'} icon={faCheck} /></Tooltip>
                    </Box>
                  </TableCell>
              </TableRow>:
              (
                isAddLoading &&
                <TableSkeleton rowCount={1} cellCount={6} />
              )
            }
            {visibleRows?.length ? (
              <TableBody>
                {visibleRows.map((d: any, i: number) => (
                  <TableRow
                    className="hoverBG"
                    sx={{ cursor: "pointer" }}
                    key={`standards-table-row-${i}`}
                  >
                    <TableCell className='fs12'>
                      {i+1}
                    </TableCell>
                    <TableCell className="fs12" sx={{ maxWidth: '600px' }}>
                      {d.Name}
                    </TableCell>
                    <TableCell className="fs12" sx={{ maxWidth: '600px' }}>
                      {d.Description}
                    </TableCell>
                    <TableCell className="fs12">
                      {
                        d.Standards?.length > 0 ?
                        (d.Standards?.length == 1 ?
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Chip className='chipStyle' label={genUID(d.Standards[0].Uid)} color="primary" />
                            <Typography className='fs12'>{d.Standards[0].StandardName}</Typography> 
                          </Box>: 
                        <Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Chip className='chipStyle' label={genUID(d.Standards[0].Uid)} color="primary" />
                            <Typography className='fs12'>{d.Standards[0].StandardName}</Typography> 
                          </Box>
                          <Tooltip title={d.Standards.map((obj:any) => `${genUID(obj.Uid)} ${obj.StandardName}`).join(', ')} arrow placement='top'>
                            <Chip className='chipStyle' sx={{ ml: '0px !important' }} label={'+' + (d.Standards.length - 1)} color="primary" />
                          </Tooltip>
                        </Box>
                        ) : ''
                      }
                    </TableCell>
                    <TableCell className="fs12" sx={{ maxWidth: '600px' }}>
                      <NestedThreeDotMenu options={threeDotMenuOptions} manageClick={(e:any) => {handleThreedotMenuClick(e, d)}} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                {/* <TableSkeleton rowCount={8} cellCount={5} /> */}
                <TableRow>
                    <TableCell className="fs12" colSpan={6}>
                      {t('NO_RECORDS_FOUND')}
                    </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>
    </React.Fragment>
  );
};

export default ReportsActionsTable;
